import React from 'react';
import './Features.css';

import { features } from '../../../constants';
import { Feature } from '../../../components';



const Features = () => {

  return (
    <section className='features'>
      <div className="box-container">

        {/* Map over the features array to render each feature */}
        {features.map((feature) => (

          /* Render individual Feature component */
          <Feature key={feature.id} feature={feature} />
        ))}
      </div>
    </section>
  );
}

export default Features;